import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostIncomeTaxDetails,
	PostIncomeTaxDetailsParams,
	PostIncomeTaxDetailsModel,
} from 'domain/usecases';

export class RemotePostIncomeTaxDetails implements PostIncomeTaxDetails {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostIncomeTaxDetailsModel>,
	) {}

	async post({
		signal,
		...params
	}: PostIncomeTaxDetailsParams): Promise<PostIncomeTaxDetailsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
